module.exports = __webpack_public_path__ + "img/newWhiteCam.a0125a83.svg";